/**
 * Manager to execute non-essential work on idle time
 * Wrapper for IdleQueue
 */
import { IdleQueue } from 'Lib/vendors/idlize/IdleQueue';

class RequestIdleCallbackManager {
  tasks: typeof IdleQueue;

  constructor() {
    this.tasks = __CLIENT__ ? new IdleQueue({ ensureTasksRun: true }) : null;
  }

  addTask = (task: Function) => {
    if (this.tasks) {
      this.tasks.pushTask(task);
    }
  };
}

export default new RequestIdleCallbackManager();
